'use client';

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import Copy from '@nib-components/copy';
import Heading from '@nib-components/heading';
import { Box, Columns, Column, Stack, pl, px, py } from '@nib/layout';
import { formBoxShadow, boxShadowStandard, token, borderRadiusStandard } from '@nib-components/theme';
import { pickBackgroundColor, pickBorderColor, renderIcon } from './utils';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Wrapper = styled(_ref => {
  let {
    fullWidth,
    type,
    variation,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ...rest
  });
})`
  display: inline-block;
  box-sizing: border-box;
  max-inline-size: 100%;
  inline-size: ${props => props.fullWidth ? '100%' : 'auto'};
  position: relative;
  overflow: hidden;
  box-shadow: ${boxShadowStandard || formBoxShadow};

  ${props => props.variation === 'soft' && css`
      border-radius: ${borderRadiusStandard};

      &::before {
        content: '';
        display: block;
        inline-size: ${token('theme.dimension.border.width.medium', '4px')};
        background: ${pickBorderColor(props.type)};
        position: absolute;
        inset-block: 0;
        inset-inline-start: 0;
      }
    `};

  ${props => props.variation === 'loud' && css`
      border: ${token('theme.dimension.border.width.medium', '4px')} solid ${pickBorderColor(props.type)};
      border-inline-start: 12px solid ${pickBorderColor(props.type)};
    `};
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StyledBox = styled(_ref2 => {
  let {
    variation,
    type,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsx(Box, {
    width: "100%",
    ...rest
  });
})`
  ${py({
  xs: 2,
  sm: 4
})};
  ${px({
  xs: 2,
  sm: 5
})};

  ${props => props.variation === 'soft' && css`
      background-color: ${pickBackgroundColor(props.type)};
      ${pl(4)};
    `};

  ${props => props.variation === 'loud' && css`
      background-color: ${token('theme.color.bg.surface.prominent', '#ffffff')};
    `};
`;
const Alert = props => {
  const {
    title,
    children,
    type = 'info',
    titleComponent,
    variation = 'loud',
    fullWidth = false,
    ...otherProps
  } = props;
  return /*#__PURE__*/_jsx(Wrapper, {
    variation: variation,
    fullWidth: fullWidth,
    type: type,
    "data-mesh-component": "ALERT",
    ...otherProps,
    children: /*#__PURE__*/_jsx(StyledBox, {
      type: type,
      variation: variation,
      children: /*#__PURE__*/_jsxs(Columns, {
        align: "center",
        verticalAlign: "top",
        space: {
          xs: 2,
          sm: 5
        },
        collapseBelow: "sm",
        children: [/*#__PURE__*/_jsx(Column, {
          width: "content",
          children: /*#__PURE__*/_jsx(Box, {
            display: "flex",
            width: variation === 'soft' ? '2rem' : '',
            justifyContent: {
              sm: 'center'
            },
            children: renderIcon(type)
          })
        }), /*#__PURE__*/_jsx(Column, {
          flex: true,
          children: /*#__PURE__*/_jsx(Box, {
            display: "flex",
            alignItems: "center",
            children: /*#__PURE__*/_jsxs(Stack, {
              space: {
                xs: 2,
                sm: 3
              },
              children: [title && /*#__PURE__*/_jsx(Heading, {
                component: titleComponent,
                size: 4,
                color: type,
                children: title
              }), children && /*#__PURE__*/_jsx(Copy, {
                measure: false,
                component: "div",
                children: children
              })]
            })
          })
        })]
      })
    })
  });
};
Alert.displayName = 'Alert';
export default Alert;
export { validTypeValues, validVariationValues } from './types';